import PropTypes from 'prop-types';
import React from 'react';

import EditButton from '@/features/kkmsPage/Page/Row/Actions/EditButton';

const Actions = ({ classes, kkmId }) => (
  <div className={classes.root}>
    <EditButton
      kkmId={kkmId}
      small={false}
      color="primary"
      variant="contained"
    />
  </div>
);

Actions.propTypes = {
  kkmId: PropTypes.number.isRequired,
};

export default Actions;
